export default "__VITE_ASSET__BeCUILeS__"